import { useEffect, useState } from 'react';

const ParallaxBackground = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY * 0.1);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: '-100px',
      left: 0,
      right: 0,
      bottom: '-100px',
      zIndex: -1,
      transform: `translateY(${offset}px)`,
      willChange: 'transform',
      background: `
        radial-gradient(
          circle at 70% 10%, 
          rgba(255, 0, 0, 0.5) 0%,
          rgba(255, 0, 0, 0.3) 30%,
          transparent 70%
        ),
        linear-gradient(
          135deg,
          rgba(0, 0, 20, 1) 0%,
          rgba(0, 0, 10, 1) 15%,
          rgba(10, 0, 20, 1) 100%
        ),
        radial-gradient(
          ellipse at bottom, 
          rgba(255, 255, 255, 0.05) 0%,
          transparent 70%
        )
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      overflow: 'hidden'
    }} />
  );
};

export default ParallaxBackground;